import moment from 'moment'

export default function(valueA, valueB, nodeA, nodeB, isDescending) {
  const valueAMoment = moment(valueA)
  const valueBMoment = moment(valueB)

  // If one of the values is invalid, it is considered smaller
  if (!valueAMoment.isValid() && !valueBMoment.isValid()) return 0
  if (!valueAMoment.isValid()) return isDescending ? 1 : -1
  if (!valueBMoment.isValid()) return isDescending ? -1 : 1

  const valueANumber = valueAMoment.unix()
  const valueBNumber = valueBMoment.unix()

  if (valueANumber === valueBNumber) return 0
  return (valueANumber > valueBNumber) ? 1 : -1
}
